import { enUSTranslations } from '../locale/translations.js';

var useTranslations = function useTranslations(externalTranslations) {
  var replaceVariables = function replaceVariables(keyString, values) {
    return keyString.replace(/{{(.*?)}}/g, function (_match, offset) {
      return values[offset];
    });
  };
  var getTranslationForCount = function getTranslationForCount(key, count) {
    var keyWithCount = key + (count > 1 ? "_other" : "_one");
    var externalTranslationWithCount = externalTranslations && externalTranslations[keyWithCount];
    return externalTranslationWithCount || enUSTranslations[keyWithCount];
  };
  var getTranslationForKey = function getTranslationForKey(key, count) {
    if (count !== void 0) {
      var translationWithCount = getTranslationForCount(key, count);
      if (translationWithCount) {
        return translationWithCount;
      }
    }
    var externalTranslation = externalTranslations && externalTranslations[key];
    return externalTranslation || enUSTranslations[key];
  };
  var t = function t(key, values) {
    var count = values && values["count"] ? parseInt(values["count"], 10) : void 0;
    var translation = getTranslationForKey(key, count);
    if (!translation) return key;
    if (!values) return translation;
    return replaceVariables(translation, values);
  };
  return {
    t: t
  };
};

export { useTranslations };
